import { render, staticRenderFns } from "./WaybillCreateRX.vue?vue&type=template&id=012cd8da&scoped=true&"
import script from "./WaybillCreateRX.vue?vue&type=script&lang=js&"
export * from "./WaybillCreateRX.vue?vue&type=script&lang=js&"
import style0 from "./WaybillCreateRX.vue?vue&type=style&index=0&id=012cd8da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012cd8da",
  null
  
)

export default component.exports